import { useMemo, useEffect, useState } from 'react';
import { Box, Button, Icon, IconButton, LinearProgress, Pagination, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, useTheme, Tooltip, Typography } from '@mui/material';
import { useNavigate, useSearchParams } from "react-router-dom"

import { IIndice, IndiceService } from '../../shared/services/api/indice/IndiceService';
import { AlertSnackBar, AutoCompleteDeCliente } from "../../shared/components"
import { LayoutBaseDePagina } from "../../shared/layouts"
import { Environment } from '../../shared/environment';
import { IPaginacao } from '../../shared/services/api/axios-config';
import { DialogConfirm } from '../../shared/components/dialog/DialogConfirm';

export const ListagemDeIndice: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const theme = useTheme();

  const [alert, setAlert] = useState<{ tipoAlert: string, mensagem: string } | undefined>(undefined);
  const [duracaoAlert, setDuracaoAlert] = useState<number>(Environment.DURACAO_ALERT + 500);

  const [rows, setRows] = useState<IIndice[]>([]);
  const [paginacao, setPaginacao] = useState<IPaginacao>({
    totalCount: 0,
    pageSize: 0,
    currentPage: 0,
    totalPages: 0,
    hasNext: false,
    hasPrevious: false
  });
  const [isLoading, setIsLoading] = useState(true);
  const [cnpj, setCnpj] = useState<string | undefined | null>(undefined);

  function resetPaginacao() {
    setPaginacao({
      totalCount: 0,
      pageSize: 0,
      currentPage: 0,
      totalPages: 0,
      hasNext: false,
      hasPrevious: false
    });
  }

  const busca = useMemo(() => {
    return searchParams.get('busca') || '';
  }, [searchParams]);

  const pagina = useMemo(() => {
    return Number(searchParams.get('pagina') || '1');
  }, [searchParams]);

  useEffect(() => {
    handleNewSearch(false);
  }, [busca, cnpj])

  useEffect(() => {
    handleNewSearch(true);
  }, [pagina])

  const handleNewSearch = (newPage: boolean) => {
    setIsLoading(true);

    if (cnpj === undefined || cnpj === null || cnpj == '') {
      setIsLoading(false);
      setRows([]);
      resetPaginacao();
    } else {
      if (newPage) {

        IndiceService.getAll(pagina, cnpj, true).then((result) => {
          setIsLoading(false);

          if (result instanceof Error) {//verificar se deu erro

            setAlert({ tipoAlert: "erro", mensagem: result.message });
            setTimeout(() => {
              setAlert(undefined);
            }, duracaoAlert);
          }
          else {
            setPaginacao(result.paginacao);
            setRows(result.indices);
          }
        });

      } else {
        setSearchParams({ pagina: "1" }, { replace: true });

        setRows([]);
        resetPaginacao();

        IndiceService.getAll(1, cnpj, true).then((result) => {

          setIsLoading(false);

          if (result instanceof Error) {//verificar se deu erro

            setAlert({ tipoAlert: "erro", mensagem: result.message });
            setTimeout(() => {
              setAlert(undefined);
            }, duracaoAlert);
          }
          else {

            setPaginacao(result.paginacao);
            setRows(result.indices);

          }
        })
      }
    }
  };

  const handleDelete = () => {

    setAbrir(false);
    setIsLoading(true);

    IndiceService.toggleEnabledById(idToDelete).then(result => {

      setIsLoading(false);
      if (result instanceof Error) {//verificar se deu erro

        setAlert({ tipoAlert: "erro", mensagem: result.message });
        setTimeout(() => {
          setAlert(undefined);
        }, duracaoAlert);

      } else {

        setRows(oldRows => {
          return [
            ...oldRows.filter(oldRow => oldRow.idIndice !== idToDelete),
          ]
        });

        setAlert({ tipoAlert: "sucesso", mensagem: "Indice desativado com sucesso" });
        setTimeout(() => {
          setAlert(undefined);
        }, duracaoAlert);

      }
    });
  }

  const [abrir, setAbrir] = useState(false);
  const [idToDelete, setidToDelete] = useState<number>(0);

  const handleClickDelete = (idIndice: number) => {
    setAbrir(true);
    setidToDelete(idIndice);
  };

  const handleCancel = () => {
    setAbrir(false);
  };


  return (
    <LayoutBaseDePagina
      titulo="Listagem de índices"
      barraDeFerramentas={
        <Box
          component={Paper}
          height={theme.spacing(5)}
          marginX={1}
          padding={1}
          paddingX={2}
          display="flex"
          gap={1}
          alignItems="center"
        >
          <AutoCompleteDeCliente selectedCnpj={selectedCnpj => setCnpj(selectedCnpj)} />

          <Box flex={1} display="flex" justifyContent="end">
            <Button
              color="primary"
              disableElevation
              variant="contained"
              endIcon={<Icon>do_disturb</Icon>}
              onClick={() => navigate('/indice/desativado')}
            >
              Desativados
            </Button>
            <Box width={5}></Box>

            {(cnpj === "" || cnpj === null || cnpj === undefined) ?
              <Button
                color="primary"
                disableElevation
                variant="contained"
                endIcon={<Icon>add</Icon>}
                onClick={() => navigate('/indice/detalhe/novo')}
                disabled
              >
                Novo
              </Button>
              :
              <Button
                color="primary"
                disableElevation
                variant="contained"
                endIcon={<Icon>add</Icon>}
                onClick={() => navigate('/indice/detalhe/novo')}
              >
                Novo
              </Button>
            }
          </Box>
        </Box>
      }
    >
      <DialogConfirm
        AoConfirmar={handleDelete}
        titulo={"Dejesa realmente desativar o indice?"}
        texto={"Ao confirmar, o indice será desativado."}
        abrir={abrir}
        AoCancelar={handleCancel}
      />

      {alert !== undefined && (
        <>
          {alert.tipoAlert === "sucesso" && (
            <AlertSnackBar gravidade="success" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
          {alert.tipoAlert === "erro" && (
            <AlertSnackBar gravidade="error" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
          {alert.tipoAlert === "aviso" && (
            <AlertSnackBar gravidade="warning" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
        </>
      )}
      <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: 'auto' }}>
        <Table>
          <TableHead>
            <TableRow>

              <TableCell> Nome </TableCell>
              <TableCell> Tipo do componente </TableCell>
              <TableCell> Ações </TableCell>

            </TableRow>
          </TableHead>
          <TableBody>

            {rows.map(row => (
              <TableRow key={row.idIndice}>
                <TableCell> {row.nomeIndice} </TableCell>
                <TableCell>
                  {row.idComponente == 1 && ("Texto")}
                  {row.idComponente == 2 && ("Radio")}
                  {row.idComponente == 3 && ("Select")}
                  {row.idComponente == 4 && ("Marcar")}
                  {row.idComponente == 5 && ("Data")}
                  {row.idComponente == 6 && ("Período")}
                  {row.idComponente == 7 && ("Numérico")}
                  {row.idComponente == 8 && ("Intervalo Numérico")}
                  {row.idComponente == 9 && ("Intervalo Alfabético")}
                  {row.idComponente == 10 && ("CPF")}
                  {row.idComponente == 11 && ("CNPJ")}
                </TableCell>
                <TableCell>

                  <IconButton size="small" onClick={() => navigate(`/indice/detalhe/${row.idIndice}`)}>
                    <Tooltip arrow title="Editar índice">
                      <Icon> edit </Icon>
                    </Tooltip>
                  </IconButton>

                  <IconButton size="small" onClick={() => handleClickDelete(row.idIndice)}>
                    <Tooltip arrow title="Apagar índice">
                      <Icon> delete </Icon>
                    </Tooltip>
                  </IconButton>

                </TableCell>
              </TableRow>
            ))}

          </TableBody>

          {paginacao?.totalCount === 0 && !isLoading && cnpj !== undefined && cnpj !== null && cnpj != '' && (
            <caption> {Environment.LISTAGEM_VAZIA} </caption>
          )}
          {cnpj === undefined || cnpj === null || cnpj == '' && !isLoading && (
            <caption> Selecione uma empresa para pesquisar </caption>
          )}

          <TableFooter>
            {isLoading && (
              <TableRow>
                <TableCell colSpan={3}>{/* quantas colunas o loading vai ocupar */}
                  <LinearProgress variant='indeterminate' />
                </TableCell>
              </TableRow>
            )}
            {(paginacao?.totalPages > 1 && !isLoading) && (
              <TableRow>
                <TableCell colSpan={3} align="right">
                  <Box flexDirection="row" display="inline-flex">
                    <Typography noWrap marginTop={0.5} >Exibindo {paginacao.hasNext ? paginacao.pageSize * paginacao.currentPage : paginacao.totalCount} de {paginacao?.totalCount}</Typography>
                    <Pagination
                      page={pagina}
                      count={paginacao?.totalPages}
                      onChange={(_, newPage) => setSearchParams({ pagina: newPage.toString() }, { replace: true })}
                    />
                  </Box>
                </TableCell>
              </TableRow>
            )}
          </TableFooter>
        </Table>
      </TableContainer>
    </LayoutBaseDePagina>
  )
}